import React from "react";
import PropTypes from "prop-types";

import "../../styles/TextField.scss";

/**
 * Display a textarea input with a character count
 * @name TextField
 * @param {string} className,
 * @param {string} charsUsed,
 * @param {boolean} disabled,
 * @param {string} maxLimit,
 * @param {string} name,
 * @param {func} onBlur,
 * @param {func} onChange,
 * @param {string} placeholder,
 * @param {string} value
 * @return {JSX.element}
 * @constructor
 */
const TextField = ({ className, charsUsed, disabled, label, maxLimit, name, onBlur, onChange, placeholder, value }) => {
    const spacesLeft = maxLimit - charsUsed;
    const disabledColor = disabled ? "#DEDEDE" : "";

    return (
        <div className="text-container">
            <div className="text-group">
                {label && label.length && <label htmlFor={name}>{label}</label>}
                <textarea
                    className={className}
                    disabled={disabled}
                    maxLength={maxLimit}
                    name={name}
                    onBlur={onBlur}
                    onChange={onChange}
                    placeholder={placeholder}
                    style={{ backgroundColor: disabledColor }}
                    value={value}
                />
                <div className="spaces-left">{`${spacesLeft} characters left`}</div>
            </div>
        </div>
    );
};

TextField.propTypes = {
    className: PropTypes.string,
    charsUsed: PropTypes.number,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    maxLimit: PropTypes.number,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string
};

TextField.defaultProps = {
    className: "text-textarea",
    charsUsed: "",
    disabled: false,
    label: null,
    maxLimit: "",
    name: "",
    onBlur: null,
    placeholder: "Please type here",
    value: ""
};

export default TextField;
